const PrivatePolicyAction = {
    GET_PRIVATE_POLICY: "GET_PRIVATE_POLICY",
    GET_PRIVATE_POLICY_LOADING: "GET_PRIVATE_POLICY_LOADING",
    GET_PRIVATE_POLICY_FAILED: "GET_PRIVATE_POLICY_FAILED",
    GET_PRIVATE_POLICY_SUCCESS: "GET_PRIVATE_POLICY_SUCCESS",
}

export default PrivatePolicyAction;